<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.kullanici_bilgileri"  :show_button="false" ></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="mt-4">

<template v-if="userrole=='supplier'">
<ContentTable :data="suppliers" :columns="columns" routename="Supplier"  ></ContentTable>
</template>

<template v-if="userrole=='admin'">
<ContentTable :data="suppliers" :columns="columns" routename="Supplier"  ></ContentTable>
</template>

</div>
</template>

</div>
</template>

<script>
export default {

  name: 'UserSuppliers',

  data () {
    return {
    	suppliers:[],
    	loading:true,    	
	    columns:[
	      {
	        type:"text",
	        field:"name",
	        header:"tedarikci",
	        hide_on_mobile:false,
	      },
	      {
	        type:"text",
	        field:"brand_name",
	        header:"marka",
	        hide_on_mobile:true,
	      },
	    ], 

    }
  },
  computed:
  {
  	userrole()
  	{
  		let user = this.$store.state.users.user
  		if(user)
  		{
  			let userroles = this.$store.state.users.user.userroles
  			for(let element of userroles)
  			{
  				if(element.name=="supplier")
	            {
	               return "supplier"             
	            }
	            if(element.name=="admin" ||element.name=="auditor" ||element.name=="planner" )
	            {
	               return "admin"             
	            }
  			}
  		}
  		return null
  	},
  },
  mounted()
  {
    this.getData()
  },
  methods:{
     async getData()
    {
      let suppliers = await this.generalApiGetWithoutLoader("user_suppliers/"+this.$route.params.id)
      for(let item of suppliers)
      {
      	item.name = item.supplier.name
      	item.id = item.supplier.id
      	item.brand_name = item.supplier.brand.name
      }
      this.suppliers = await suppliers
      console.log(this.suppliers)
      this.loading = await false
    },
  },
}
</script>

<style lang="css" scoped>
</style>